var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{attrs:{"src":require('../../' + _vm.background),"width":450,"height":450,"alt":"banner"}})}
var staticRenderFns = []

export { render, staticRenderFns }